import React, { useState } from 'react';
import styled from 'styled-components';
import WelcomeScreen from './components/WelcomeScreen';
import AIDocumentationViewer from './components/AIDocumentationViewer';
import PopupChatWindow from './components/PopupChatWindow';

interface AIContent {
  title: string;
  content: string;
  timestamp: Date;
}

const AppContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100vh;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  background: #f5f7fa;
  position: relative;
`;

const Header = styled.header`
  background: linear-gradient(135deg, #4B0082, #6A0DAD);
  color: white;
  padding: 20px;
  text-align: center;
`;

const HeaderTitle = styled.h1`
  margin: 0;
  font-size: 24px;
  font-weight: 600;
`;

const HeaderSubtitle = styled.p`
  margin: 8px 0 0 0;
  font-size: 14px;
  opacity: 0.9;
`;

const MainContent = styled.main`
  flex: 1;
  overflow: hidden;
  display: flex;
  flex-direction: column;
`;

const App: React.FC = () => {
  const [aiContent, setAiContent] = useState<AIContent | null>(null);
  const [isChatOpen, setIsChatOpen] = useState(false);

  const handleAIResponse = (title: string, content: string) => {
    setAiContent({
      title,
      content,
      timestamp: new Date()
    });
  };

  const toggleChat = () => {
    setIsChatOpen(!isChatOpen);
  };

  return (
    <AppContainer>
      <Header>
        <HeaderTitle>📚 AI Documentation Viewer</HeaderTitle>
        <HeaderSubtitle>
          Ask questions about our applications and get instant documentation
        </HeaderSubtitle>
      </Header>
      
      <MainContent>
        {aiContent ? (
          <AIDocumentationViewer 
            title={aiContent.title}
            content={aiContent.content}
            timestamp={aiContent.timestamp}
          />
        ) : (
          <WelcomeScreen onGetStarted={toggleChat} />
        )}
      </MainContent>

      <PopupChatWindow
        isOpen={isChatOpen}
        onToggle={toggleChat}
        onAIResponse={handleAIResponse}
      />
    </AppContainer>
  );
};

export default App;
